import { makeStyles } from '@material-ui/core';
import { Mixin } from '@monorepo/common';
import { TOKENS } from '../../styles/tokens';

export const useStyles = makeStyles((theme) => ({
  location_wrapper: {
    '& ~ $location_wrapper': {
      marginTop: 45
    }
  },
  final_block_item: {
    '&$final_block_item': {
      marginTop: 20,
    }
  },
  last_field: {
    marginBottom: 10
  },
  root: {
    paddingTop: '2rem',
    ...Mixin.mixin.flex('flex-start', 'center'),
    '@media(max-width: 1200px)': {
      display: 'block'
    }
  },
  wrapper_card: {
    padding: '40px 20px',
    position: 'relative',
    borderRadius: theme.shape.borderRadius
  },
  description_page: {
    '& h1': {
      textAlign: 'center'
    },
    '@media(max-width: 1200px)': {
      maxWidth: '100%',
      marginTop: '2rem',
    },
    '& p, & b,& li': {
      fontSize: 16
    },
    '& ul': {
      paddingLeft: '1.3rem'
    },
    '& p, & ul': {
      marginBottom: '1rem'
    },
    '& li': {
      marginBottom: '.7rem'
    },
  },
  table_wrapper: {
    maxWidth: '100%',
    overflowX: 'auto',
    ...Mixin.mixin.br()
  },
  link: {
    color: theme.palette.error.main
  },
  wrapper_for_steps: {
    width: '100%',
    maxWidth: '50rem',
    '& .MuiAvatar-root': {
      backgroundColor: '#e21836'
    },
    '@media(max-width: 1200px)': {
      maxWidth: '100%',
    }
  },
  active_step: {
    padding: '32px 8px 32px 20px',
    borderLeft: '2px solid rgb(230, 232, 240) !important',
    marginLeft: '20px !important'
  },
  stepper: {
    '& .MuiStepConnector-line': {
      ml: 1,
      borderLeftColor: 'divider',
      borderLeftWidth: 2
    }

  },
  step3_address_wrap: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridAutoRows: '1fr',
    gap: '1rem',
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
    }
  },
  error: {},
  error_text: {
    position: 'absolute',
    left: 0,
    bottom: '-23px',
    color: 'red'
  },
  multiple_job_listing: {
    marginTop: 24
  },
  text_error: {
    fontSize: 'inherit',
    textDecoration: 'none',
    color: theme.palette.error.main
  },
  couple_line: {
    ...Mixin.mixin.flex('flex-start', 'center'),
    gridGap: '1rem',
    '@media(max-width: 768px)': {
      display: 'block'
    },
    '& > div': {
      flex: 1
    }
  },
  card: {
    fill: 'red'
  },
  wrapper_for_additional_email: {
    ...Mixin.mixin.flex('center', 'space-between'),
    '& + $wrapper_for_additional_email': {
      marginTop: '1rem'
    }
  },
  additional_email: {
    marginBottom: 0,
    flex: 1
  },
  additional_email_remove: {
    cursor: 'pointer',
    marginLeft: '1rem',
    '&:hover': {
      fill: TOKENS.danger
    }
  },
  logoFieldError: {
    background: 'red'
  },
  wrapper_for_radio_group: {
    '@media(max-width: 650px)': {
      '& label': {
        margin: 0,
        alignItems: 'flex-start'
      }
    }
  },
  left: {
    order: 0
  },
  right: {
    order: 1,
    textAlign: 'center'
  },
  line: {
    marginLeft: 15,
    ...Mixin.mixin.flex(),
    '@media(max-width: 650px)': {
      marginLeft: 0,
      display: 'block',
      textAlign: 'center'
    },
    '& $left': {
      paddingRight: 10,
      width: 'calc(100% - 10rem)',
      '@media(max-width: 650px)': {
        width: '100%',
        paddingRight: 0,
      }
    },
    '& $right': {
      width: '100%',
      maxWidth: '10rem',
      '@media(max-width: 650px)': {
        margin: '0 auto 20px'
      }
    },
  }
}));
